import { MkField } from "./MkField";

export interface Option {
    value: string;
    label: string;
}

interface Props {
    label?: string;
    hint?: string;
    error?: string;
    required?: boolean;
    value?: string | number | boolean | null;
    options: (Option | string)[];
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    onChange(value: string): void;
}

export function MkSelect({ label, hint, error, required, value, options, placeholder,
                           disabled, className, onChange }: Props) {
    const hasValue = !(value === undefined || value === null || value === false || value === "");
    const current = hasValue ? String(value) : "";
    const normalized = options.map((option) => (
        typeof option === "object" ? option : { value: option, label: option }));
    return (
        <MkField label={label} hint={hint} error={error} required={required}
                 className={className}>
            <div className="mk-select">
                <select disabled={disabled} value={current}
                        onChange={(event) => onChange(event.target.value)}>
                    {(!required || !hasValue) && (
                        <option value="" disabled={Boolean(required)}>{placeholder || ""}</option>
                    )}
                    {normalized.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </select>
                <i className="fa fa-angle-down mk-select-caret" />
            </div>
        </MkField>
    );
}
